import { render } from "./ViewHeader.vue?vue&type=template&id=8f057cfe&scoped=true"
import script from "./ViewHeader.vue?vue&type=script&lang=js"
export * from "./ViewHeader.vue?vue&type=script&lang=js"

import "./ViewHeader.vue?vue&type=style&index=0&id=8f057cfe&scoped=true&lang=scss"

import exportComponent from "/home/forge/hostess.posnania.expansja.pl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f057cfe"]])

export default __exports__